import { BuildFontString } from "./BuildFontString";
import { enumFontIconWeights } from "../constants";
import { QFALabelButton } from "../CoreApp/QFALabelButton";
import { fontIconString } from "./fontIconString.js";

export function AddCustomFALabelButton(
  parent,
  cmdCode,
  label,
  labelSize,
  faIcon,
  x,
  y,
  boldLabel,
  iconWeight,
  iconSize
) {
  // custom weight
  var fAWeight = boldLabel ? enumFontIconWeights.bold : enumFontIconWeights.regular;
  if (iconWeight != null && Object.values(enumFontIconWeights).indexOf(iconWeight.toString()) > -1)
    fAWeight = iconWeight;

  var iconFontSize = labelSize;
  if (iconSize) iconFontSize = iconSize;
  // font size of icon matches font size of label in pixels
  var fAStyle = fontIconString(iconFontSize, fAWeight);

  // add button using above params
  var button = new QFALabelButton();
  button.fLabelFontSize = labelSize;
  button.SetFAStyle(fAStyle);
  button.fFontString = BuildFontString("Arial", labelSize, boldLabel, false);
  button.InitButton(parent, cmdCode, x, y, label, faIcon);
  button.fBorderColor = null;
  button.AutoSize();

  return button;
}
